import { renderLoader } from '../renderLoader';
import { getState, modifyState } from '~src/state';

export const formatAutoSelect = (formatId) => {
  const project = getState('selected.tipo');

  window.urlParams.set('formato', formatId);
  window.history.replaceState(
    {},
    '',
    `${window.location.href.split('?')[0]}?` + window.urlParams
  );

  const format = window.editorLoader.formats[
    project.objectId
  ].formats.items.find((format) => format.objectId === formatId);

  modifyState('selected.formato', format);
  modifyState(
    'selected.formatoDefault',
    format.editor_project_formats_default_pointer
  );

  setTimeout(async () => {
    await renderLoader();
  }, 0);
};
